import { render } from "./AddProductsToCustomer.vue?vue&type=template&id=166ad142&scoped=true"
import script from "./AddProductsToCustomer.vue?vue&type=script&lang=js"
export * from "./AddProductsToCustomer.vue?vue&type=script&lang=js"

import "./AddProductsToCustomer.vue?vue&type=style&index=0&id=166ad142&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166ad142"]])

export default __exports__